import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import styles from '../EditTeamMember.module.css';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useEditTeamMember } from '../EditTeamMemberContext';
import { AdminSelect } from '@project/components';

export const EditTeamMemberCompanyRole = props => {
  const { roleOptions } = props;
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const { companyRole, setCompanyRole, companyLevelAcl, setIsDirty, setCompanyLevelAcl } = useEditTeamMember();

  useEffect(() => {
    if (companyLevelAcl) {
      const _companyRole = roleOptions.find(role => role.value === companyLevelAcl.roleid);
      setCompanyRole(_companyRole ?? roleOptions[0]);
    }
  }, [companyLevelAcl, roleOptions, setCompanyRole]);

  const doOnChange = (newRole) => {
    setCompanyLevelAcl(prevState => ({ ...prevState, roleid: newRole.value }));
    setCompanyRole(newRole);
    setIsDirty(true);
  }

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription title={t('EditTeamMember.role.title')} description={t('EditTeamMember.role.details')} />
      </LeftColumn>
      <RightColumn>
        <div>
          <AdminSelect
            id="companyRole"
            propStyles={styles.adminSelect}
            label={t('EditTeamMember.role.label')}
            options={roleOptions}
            value={companyRole}
            onChange={doOnChange}
            isLoading={false}
          />
          <div className="pt-2">{companyRole.desc}</div>
        </div>
      </RightColumn>
    </TwoColumnContent>
  );
};
